import { plainToInstance, Transform, Type } from 'class-transformer'
import Vue from 'vue'

import { IMessageSettings } from './Body/logic/types'
import { BaseButton } from './ButtonsConstructor/Buttons/types'
import MessageEditorModelButtonsFactory from './ButtonsConstructor/logic/MessageEditorModelButtonsFactory'
import { MessageButtons } from './ButtonsConstructor/logic/types'
import { CustomMediaFileData } from './Media/logic/MediaFileData'
import { FileType, MessageAttachment, MessageMedia } from './Media/types'

export type IMessageTemplate = IMessageSettings & MessageMedia & MessageButtons

export default class MessageEditorWithMediaData implements IMessageTemplate {
  /* Message-settings */
  text!: string
  topics?: Array<number>

  pin!: boolean
  disable_link_preview!: boolean
  disable_notify!: boolean
  remove_previous!: boolean
  protect_content!: boolean
  remove_after!: number
  send_after!: number

  /*Message media*/
  @Type(() => MessageAttachment)
  attachments!: Array<MessageAttachment>

  /*Message buttons*/
  @Transform(({ value }) => {
    return value.map((r: Array<any>) => {
      return r.map((b) => {
        const factory = MessageEditorModelButtonsFactory.ModelsFactories.find((f) => f.name === b.type)

        if (factory) {
          return plainToInstance(factory.value, b)
        }

        return BaseButton
      })
    })
  })
  buttons!: Array<Array<BaseButton>>
}

export type CustomMediaTypes = {
  classParser: (file: MessageAttachment) => CustomMediaFileData,
  types: Array<{
    type: FileType
    subType: string
    icon: string
    view: typeof Vue
  }>
}

